import { createContext, useContext } from 'react';
import { HubConnection } from '@microsoft/signalr';

export type SignalRContextType = {
  connection: HubConnection | null;
  isConnected: boolean;
  error: Error | null;
  hasPersistedError: boolean;
  connectToSystem: (systemId: string) => Promise<void>;
  scheduleDisconnectFromSystem: (systemId: string) => void;
  disconnect: () => Promise<void>;
  currentSystemId: string | null;
  registerActiveRefresh: (systemId: string) => void;
  unregisterActiveRefresh: (systemId: string) => void;
  isRefreshActive: (systemId: string) => boolean;
  leaveSystemGroup: (systemId: string, connectionId: string) => Promise<void>;
};

export const SignalRContext = createContext<SignalRContextType>({
  connection: null,
  isConnected: false,
  error: null,
  hasPersistedError: false,
  connectToSystem: async () => {
  },
  scheduleDisconnectFromSystem: () => {
  },
  disconnect: async () => {
  },
  currentSystemId: null,
  registerActiveRefresh: () => {
  },
  unregisterActiveRefresh: () => {
  },
  isRefreshActive: () => false,
  leaveSystemGroup: async () => {
  },
});

export const useSignalR = () => {
  const context: SignalRContextType = useContext(SignalRContext);
  if (!context) {
    throw new Error('useSignalR must be used within a SignalRProvider');
  }
  return context;
};
